/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CreateInvoiceForm_invoiceTypes$ref: FragmentReference;
declare export opaque type CreateInvoiceForm_invoiceTypes$fragmentType: CreateInvoiceForm_invoiceTypes$ref;
export type CreateInvoiceForm_invoiceTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string
  |}>,
  +$refType: CreateInvoiceForm_invoiceTypes$ref,
|};
export type CreateInvoiceForm_invoiceTypes$data = CreateInvoiceForm_invoiceTypes;
export type CreateInvoiceForm_invoiceTypes$key = {
  +$data?: CreateInvoiceForm_invoiceTypes$data,
  +$fragmentRefs: CreateInvoiceForm_invoiceTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CreateInvoiceForm_invoiceTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a6a21a73f278d7aaeddd51fff6843213';
module.exports = node;
